
<template>
  <div class="main">
    <div class="head">
      <myheadert></myheadert>
      <img src="~@/assets/aboutMe_img/u6086-4.png" class="title">
    </div>
    <div class="middle">
      <div class="location">
        <img src="~@/assets/common_img/house.png">
        <span class="place">您的位置：&nbsp;<span @click="goHome">主页</span>＞商用解决方案＞成功案例</span>
      </div>
      <div class="lead">
        <ul>
          <li><a href="#/work">企业业绩</a></li>
          <li class="lead_two"><a href="#/success">成功案例</a></li>
        </ul>
      </div>
      <div class="line"></div>
    </div>
    <div class="success">
    <el-carousel indicator-position="outside" height="680px" trigger="click">
    <el-carousel-item v-for="(item,index) in list_img" :key="index">
      <img :src="item.url">
    </el-carousel-item>
  </el-carousel>
    </div>
  </div>
</template>
<script>
// import '../../assets/styles/zmd.css'
export default{
  // name: 'carousel',
  // props: {
  //   dataHeight: {
  //     type: String,
  //     default: '680px'
  //   }
  // },
  data () {
    return {
      list_img: [
        {url: require('@/assets/success_img/success1.jpg')},
        {url: require('@/assets/success_img/success2.jpg')},
        {url: require('@/assets/success_img/success3.jpg')},
        {url: require('@/assets/success_img/success4.jpg')},
        {url: require('@/assets/success_img/success5.jpg')},
        {url: require('@/assets/success_img/success6.jpg')},
        {url: require('@/assets/success_img/success7.jpg')},
        {url: require('@/assets/success_img/success8.jpg')},
        {url: require('@/assets/success_img/success9.jpg')},
        {url: require('@/assets/success_img/success10.jpg')},
        {url: require('@/assets/success_img/success11.jpg')},
        {url: require('@/assets/success_img/success12.jpg')},
        {url: require('@/assets/success_img/success13.jpg')},
        {url: require('@/assets/success_img/success14.jpg')},
        {url: require('@/assets/success_img/success15.jpg')},
        {url: require('@/assets/success_img/success16.jpg')},
        {url: require('@/assets/success_img/success17.jpg')}
      ]
    }
  },
  methods: {
    goHome () {
      this.$router.push(
        {
          path: '/'
        }
      )
      location.reload()
    }
  }

}

</script>
<style scoped>
/* @import url("//unpkg.com/element-ui@2.15.5/lib/theme-chalk/index.css"); */
.success{
  padding-bottom: 100px;
}
.success>>>.el-carousel__indicators--outside button{
  background-color: black;
}
.success>>>.el-carousel__button{
  height: 6px;
  border-radius: 5px;
}
@media screen and (min-width: 1500px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 900px;
  margin-top: 25px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: 1%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 12%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 成功案例 */
.success{
  width: 74%;
  height: 680px;
  /* border: black 1px solid; */
  margin-left: 13%;
}
.success img{
  /* width: 100%; */
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 750px;
  margin-top: 20px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -3%;
  margin-left: 14.5%;
  font-size: 18px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 15%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 成功案例 */
.success{
  width: 74%;
  height: 680px;
  /* border: black 1px solid; */
  margin-left: 13%;
}
.success img{
  /* width: 100%; */
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
}
@media screen and (min-width: 960px) and (max-width:1199px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 600px;
  /* margin-left: 20px; */
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -6%;
  margin-left: 14.5%;
  font-size: 16px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 27px;
  float: left;
  text-align: center;
  line-height: 27px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 15px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 26px;
}
/* 成功案例 */
.success{
  width: 74%;
  height: 680px;
  /* border: black 1px solid; */
  margin-left: 13%;
}
.success img{
  width: 90%;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
}
@media screen and (min-width: 768px) and (max-width:959px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 400px;
  /* margin-left: 30px; */
  /* margin-top: 10px; */
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  /* border: 1px red solid; */
  margin-top: -11%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 成功案例 */
.success{
  width: 74%;
  height: 680px;
  /* border: black 1px solid; */
  margin-left: 13%;
}
.success img{
  width: 80%;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
}
@media screen and (min-width: 702px) and (max-width:767px){
  /* 顶部 */
.head{
  width: 100%;
  height: 253px;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% auto;
  background-repeat: no-repeat;
}
.title{
  width: 500px;
  margin-left: 50px;
}
/* 位置 */
.location{
  width: auto;
  height: 27px;
  /* border: 1px red solid; */
  margin-top: -12%;
  margin-left: 14.5%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 3%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
.lead{
  margin-left: 61%;
  margin-bottom: 0;
}
.lead ul{
  list-style: none;
}
.lead ul li{
  width: 20%;
  height: 20px;
  float: left;
  text-align: center;
  line-height: 20px;
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 20px;
}
/* 成功案例 */
.success{
  width: 74%;
  height: 680px;
  /* border: black 1px solid; */
  margin-left: 13%;
}
.success img{
  width: 90%;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
}
@media screen and (max-width:701px){
    .main{
    width: 100%;
    height: auto;
  }
      /* 顶部 */
.head{
  width: 100%;
  height: auto;
  background-image: url('~@/assets/project_img/01835-crop-u6721.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.title{
  width: 50%;
  margin-left: 30%;
  margin-top: 10px;
}
/* 位置 */
.location{
  width: auto;
  height: 20px;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 12px;
  font-family: "宋体";
  /* color: black; */
}
.location img{
  width: 6%;
  display: inline-block;
}
.place{
  position: relative;
  left: 0.2%;
  top: -5px;
  cursor: pointer;
}
/* 关于我们-导航 */
/* .lead{
  margin-left: 61%;
  margin-bottom: 0;
} */
.lead ul{
  list-style: none;
  margin-top: 20px;
  margin-left: 30%;
}
.lead ul li{
  width: 25%;
  height: 14px;
  float: left;
  text-align: center;
  line-height: 12px;
  /* margin-left: 10px; */
}
.lead a{
  text-decoration: none;
  color: black;
  font-family: "黑体";
  font-size: 12px;
}
.lead_two{
  background-color: #F15A24;
}
/* 线 */
.line{
  width: 100%;
  height: 1px;
  background-color: black;
  margin-top: 34px;
}
/* 成功案例 */
.success{
  width: 74%;
  height: 580px;
  /* border: black 1px solid; */
  margin-left: 13%;
}
.success img{
  width: 100%;
  position: relative;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);
}
}

</style>



// WEBPACK FOOTER //
// src/components/project/success.vue